import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from "react-router-dom";

export default function Custompopup(props: any) {
  const { handleClose, open,title,contenttext } = props
  const navigate = useNavigate();

  const handleGoTo = () => {
    navigate("/unauthrizedAppointmentBooking");
  };

  return (

    <Dialog
      closeAfterTransition={true}
      disableEscapeKeyDown={true}
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          // Set 'open' to false, however you would do that with your particular code.
          handleClose();
        }
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle sx={{color:"red"}} id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent >
        <DialogContentText id="alert-dialog-description" >
          {contenttext}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Return</Button>
        <Button onClick={handleGoTo} autoFocus>
          Proceed
        </Button>
      </DialogActions>
    </Dialog>

  );
}
